(function() {
    'use strict';

    angular.module('app.comprobantesPago', []);
})();
